import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSendLater: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="send-later, timeslot, clock"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" strokeDasharray="4 2"/><circle cx="12" cy="12" r="6.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 8.5V12L14.5 14.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSendLater;
